import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";

const UploadOrgEmailSuccess = () => {
    useEffect(() => {
        const heading = document.querySelector("h1.lg-msg");
        if (heading) {
            heading.setAttribute("tabindex", "-1");
            heading.focus();
        }
    }, []);

    return (
        <Layout>
            <HeaderOrg />
            <main className="layout-container">
                <div className="container ctr sp-pad1">
                    <div className="bi-success-check">
                    <i className="bi bi-check2-circle" aria-hidden="true"></i>
                </div>
                <h1 className="lg-msg">
                    Organization email upload has started successfully.
                </h1>
                <p className="text-size6 spacer-margin3">
                    All emails will be added as soon as possible, depending on the number of emails being processed. <br />To check the current list, please use the button below.
                </p>
                <Link to={"/emails"} className="btn btn-primary">
                    Manage Emails
                </Link>
                {/*<Link to={"/upload-status"} className="btn btn-primary" role="button">*/}
                {/*  Upload Status*/}
                {/*</Link>*/}
            </div>
        </main>
        </Layout>
    )
};

export default UploadOrgEmailSuccess;
